export const book = {
  editDocumentParticipant: 'editDocumentParticipant',
  inviteDocumentParticipant: 'inviteDocumentParticipant',
  documentQRCode: 'qr',
};
